import type { RoleAccessRule } from './roleAccess'
import type { RecordAccess } from './useRecordAccess'
import type { PermissionSetEntity, RecordPermissionsFor } from '@omnea-app/authz'

/**
 * `roleRule` decides for an organisation not on the permissions service; an unanswered check is not
 * permitted.
 *
 * TODO(Permissions): take only a `RoleAccessRule`. The remaining booleans read per-record facts a
 * `RoleAccessContext` cannot hold, and need those facts to reach it first.
 */
export const isPermitted = <Entity extends PermissionSetEntity>(
  access: RecordAccess<Entity>,
  permission: keyof RecordPermissionsFor<Entity>,
  roleRule: RoleAccessRule | boolean
): boolean => {
  switch (access.status) {
    case 'role':
      return typeof roleRule === 'boolean' ? roleRule : roleRule(access.roleContext)
    case 'loading':
    case 'unavailable':
      return false
    case 'resolved':
      return access.permissions[permission] === true
  }
}
